// src/features/engine/tasks/osrboi/components/OSRBOIPlayer.js

export default function OSRBOIPlayer({ sample }) {

  if (!sample) return null;

  return (
    <div>
      <audio controls src={`/${sample.sampleLink}`} />
    </div>
  );
}